import script from "./ThreeDots.vue?vue&type=script&setup=true&lang=js"
export * from "./ThreeDots.vue?vue&type=script&setup=true&lang=js"

import "./ThreeDots.vue?vue&type=style&index=0&id=33a1fcf4&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33a1fcf4"]])

export default __exports__